<template>
	<div class="Menu">
		<div class="right">
			<div class="user-profile-info">
				<div>
					<router-link :to="{ name: 'profile' }" v-if="useRouterLink()">
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M14.3 14.06l-.18-.06a7.1 7.1 0 003-6 5.07 5.07 0 00-5-5 5.07 5.07 0 00-5 5 7.11 7.11 0 003 6l-.18.09c-3.37 1.5-6.86 3-5.79 6.26l.22.68h15.5l.22-.68c1.07-3.24-2.42-4.79-5.79-6.29zM9.14 8a3 3 0 016 0c0 2.07-.89 3.59-3 4.92-2.14-1.33-3-2.85-3-4.92zM6 19c.18-.77 1.31-1.57 4.77-3.11.48-.22.92-.43 1.34-.66.42.23.87.44 1.35.66 3.54 1.54 4.62 2.34 4.79 3.11z"/></svg>
					</router-link>
					<a
						:href="isEn() + `/${$t('routes.book')}/${$t('routes.profile')}`"
						v-else
					>
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M14.3 14.06l-.18-.06a7.1 7.1 0 003-6 5.07 5.07 0 00-5-5 5.07 5.07 0 00-5 5 7.11 7.11 0 003 6l-.18.09c-3.37 1.5-6.86 3-5.79 6.26l.22.68h15.5l.22-.68c1.07-3.24-2.42-4.79-5.79-6.29zM9.14 8a3 3 0 016 0c0 2.07-.89 3.59-3 4.92-2.14-1.33-3-2.85-3-4.92zM6 19c.18-.77 1.31-1.57 4.77-3.11.48-.22.92-.43 1.34-.66.42.23.87.44 1.35.66 3.54 1.54 4.62 2.34 4.79 3.11z"/></svg>
					</a>
					<span v-if="checkUserLoggedIn === true" class="user-profile-nowrap">
						{{ $t('cart.hello') }},
						<router-link :to="{ name: 'profile' }" v-if="useRouterLink()">
							{{ this.$store.state.user.name }}
						</router-link>
						<a
							:href="isEn() + `/${$t('routes.book')}/${$t('routes.profile')}`"
							v-else
						>
							{{ this.$store.state.user.name }}
						</a>
					</span>
					<span v-else class="user-profile-login">
						<router-link :to="{ name: 'login' }" v-if="useRouterLink()">
							{{ $t('cart.login') }}
						</router-link>
						<a
							:href="isEn() + `/${$t('routes.book')}/${$t('routes.login')}`"
							v-else
						>
							{{ $t('cart.login') }}
						</a>
						<router-link :to="{ name: 'newaccount' }" v-if="useRouterLink()">
							{{ $t('cart.createAccount') }}
						</router-link>
						<a
							:href="
								isEn() + `/${$t('routes.book')}/${$t('routes.createProfile')}`
							"
							v-else
						>
							{{ $t('cart.createAccount') }}
						</a>
					</span>
				</div>
			</div>

			<div
				class="book-button"
				:class="{ 'book-button--active': isActive }"
				@click="toggleBookingMenu"
			>
				{{ $t('navigation.book') }}
			</div>

			<div class="cart-info">
				<router-link :to="{ name: 'cart' }" v-if="useRouterLink()">
					<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M22 2h-3a1 1 0 00-1 .82l-.39 2.1H3a1 1 0 00-.8.4 1 1 0 00-.2.88L4 13a1 1 0 00.88.72l12 1a1 1 0 01.8.26 1 1 0 01-.68 1.77H5a1 1 0 000 2h.55a2.09 2.09 0 000 .5 2.5 2.5 0 005 0 2.73 2.73 0 00-.05-.5h2.1a2.73 2.73 0 000 .5 2.5 2.5 0 104.94-.54 3 3 0 00.62-5.71l1.67-9H22a1 1 0 000-2zm-5.82 10.68l-10.41-.87-1.44-4.89h12.92zM8 20.75a1.5 1.5 0 01-1.5-1.5 1.72 1.72 0 01.11-.5 1.56 1.56 0 01.22-.4 1.77 1.77 0 01.31-.3 1.62 1.62 0 01.37-.19h.08a1.34 1.34 0 01.84 0h.08a1.62 1.62 0 01.37.19 1.77 1.77 0 01.31.3 1.56 1.56 0 01.22.4 1.43 1.43 0 01.09.5 1.5 1.5 0 01-1.5 1.5zm7 0a1.5 1.5 0 01-1.5-1.5 1.72 1.72 0 01.11-.5 1.56 1.56 0 01.22-.4 1.77 1.77 0 01.31-.3 1.62 1.62 0 01.37-.19h.08a1.34 1.34 0 01.84 0h.08a1.62 1.62 0 01.37.19 1.77 1.77 0 01.31.3 1.56 1.56 0 01.22.4 1.43 1.43 0 01.09.5 1.5 1.5 0 01-1.5 1.5z"/></svg>
					<transition name="wave">
						<span v-if="animate" class="cart-counter cart-counter__wave"></span>
					</transition>

					<transition name="number">
						<span
							v-if="getCartItems > 0"
							class="cart-counter cart-counter__number"
						>
							<span>{{ getCartItems }}</span>
						</span>
					</transition>
				</router-link>
				<a :href="isEn() + `/${$t('routes.book')}/${$t('routes.cart')}`" v-else>
					<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M22 2h-3a1 1 0 00-1 .82l-.39 2.1H3a1 1 0 00-.8.4 1 1 0 00-.2.88L4 13a1 1 0 00.88.72l12 1a1 1 0 01.8.26 1 1 0 01-.68 1.77H5a1 1 0 000 2h.55a2.09 2.09 0 000 .5 2.5 2.5 0 005 0 2.73 2.73 0 00-.05-.5h2.1a2.73 2.73 0 000 .5 2.5 2.5 0 104.94-.54 3 3 0 00.62-5.71l1.67-9H22a1 1 0 000-2zm-5.82 10.68l-10.41-.87-1.44-4.89h12.92zM8 20.75a1.5 1.5 0 01-1.5-1.5 1.72 1.72 0 01.11-.5 1.56 1.56 0 01.22-.4 1.77 1.77 0 01.31-.3 1.62 1.62 0 01.37-.19h.08a1.34 1.34 0 01.84 0h.08a1.62 1.62 0 01.37.19 1.77 1.77 0 01.31.3 1.56 1.56 0 01.22.4 1.43 1.43 0 01.09.5 1.5 1.5 0 01-1.5 1.5zm7 0a1.5 1.5 0 01-1.5-1.5 1.72 1.72 0 01.11-.5 1.56 1.56 0 01.22-.4 1.77 1.77 0 01.31-.3 1.62 1.62 0 01.37-.19h.08a1.34 1.34 0 01.84 0h.08a1.62 1.62 0 01.37.19 1.77 1.77 0 01.31.3 1.56 1.56 0 01.22.4 1.43 1.43 0 01.09.5 1.5 1.5 0 01-1.5 1.5z"/></svg>
					<span v-if="animate" class="cart-counter cart-counter__wave"></span>
					<span
						v-if="getCartItems > 0"
						class="cart-counter cart-counter__number"
					>
						<span>{{ getCartItems }}</span>
					</span>
				</a>
			</div>
			<BookingMenu
				ref="bookingMenu"
				:show="showBookingMenu"
				@close="closeBookingMenu"
				:OutsideClose="true"
			/>
		</div>
	</div>
</template>

<script>
import store from '../../vueX/store'
import BookingMenu from '../molecules/BookingMenu'

export default {
	name: 'Menu',
	components: {
		BookingMenu
	},
	store,
	data() {
		return {
			isActive: false,
			animate: false,
			count: 0,
			cartCount: 0,
			showBookingMenu: false
		}
	},
	watch: {
		getCartItems(newVal, oldVal) {
			// För wave animering
			if (newVal != oldVal) {
				this.animate = !this.animate
			}
		}
	},
	created() {},
	methods: {
		useRouterLink() {
			return this.$route.name ? true : false
		},
		isEn() {
			return window.location.href.includes('/en/') ? '/en' : ''
		},
		//RE-DO toggle methods!
		toggleBookingMenu: function () {
			this.isActive = !this.isActive
			this.showBookingMenu = !this.showBookingMenu
			// this.$refs.bookingMenu.showBookingMenu()
		},
		closeBookingMenu() {
			this.showBookingMenu = false
			this.isActive = false
		}
		// hideBookingMenu: function () {
		// 	this.isActive = false
		// 	this.$refs.bookingMenu.hideBookingMenu()
		// },
	},
	computed: {
		getCartItems() {
			const numberOfCartItems = [].concat(
				store.state.cart.accommodation,
				store.state.cart.skipass,
				store.state.cart.skirental,
				store.state.cart.skischool,
				store.state.cart.activities
			)

			return numberOfCartItems.length
		},
		checkUserLoggedIn() {
			if (store.state.user != null) {
				return true
			} else {
				return false
			}
		}
	}
}
</script>

<style scoped lang="scss">
.Menu {
	font-family: Saira;
	// position: relative;
	top: initial;
	left: initial;
	right: initial;
	width: initial;
	padding: 0;
	padding-left: 0;
	height: 100%;
	//background-color: $colorPrimary9;
	display: flex;
	align-items: center;
	z-index: 1000;
	justify-content: flex-end;
	margin: auto;
	flex-wrap: wrap;
	pointer-events: none;

	@media only screen and (max-width: 1210px) {
		width: auto;
	}

	@include for-tablet-portrait-up {
		padding-left: 5px;
	}

	.left {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.right {
		height: 100%;
		pointer-events: all;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		overflow: hidden;

		.user-profile-info,
		.cart-info {
			position: relative;
			> div,
			> a {
				display: flex;
				align-items: center;
				margin: 0 20px;
			}

			p,
			a {
				color: $colorPrimary1;
			}

			a:hover {
				color: $colorWhite;
			}

			> span {
				font-size: 12px;
				line-height: 19px;
				font-weight: 400;
				margin: 0 0 0 20px;
			}
			span a {
				display: block;
				text-align: right;
			}

			@media only screen and (max-width: 560px) {
				.user-profile-info__title {
					display: none;
				}
			}
		}

		.user-profile-info {
			> div {
				margin: 0 20px 0 11px;
			}
			span {
				color: $colorPrimary3;
				margin: 0 0 0 13px;
			}
		}

		.user-profile-info .user-profile-nowrap {
			max-width: 80px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			margin-left: 12px;
			display: none;
			a {
				display: inline;
			}

			@include for-tablet-portrait-up {
				display: block;
			}
		}
		.user-profile-login {
			display: none;
			@include for-tablet-portrait-up {
				display: block;
			}
		}

		.cart-counter__wave {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			line-height: 15px;
			transform: scale(1);
			opacity: 0;
			background-color: $colorSecondary;
			// transition: all .3s ease-in-out;
		}

		.wave-enter-active {
			// transition: all .3s ease-in-out;
			animation: wave-in 1s;
		}

		@keyframes wave-in {
			0% {
				transform: scale(5);
				opacity: 0;
			}
			50% {
				transform: scale(1);
				opacity: 1;
			}
			100% {
				transform: scale(10);
				opacity: 0;
			}
		}

		.wave-leave-active {
			animation: wave-out 1s;
		}

		@keyframes wave-out {
			0% {
				transform: scale(5);
				opacity: 0;
			}
			50% {
				transform: scale(1);
				opacity: 1;
			}
			100% {
				transform: scale(10);
				opacity: 0;
			}
		}

		.cart-counter__number {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			line-height: 15px;
			transform: scale(1);
			background-color: $colorSecondary;
		}

		.number-enter-active {
			// transition: all .3s ease-in-out;
			animation: number-in 1s;
		}

		@keyframes number-in {
			0% {
				transform: scale(0);
				opacity: 0;
			}
			50% {
				transform: scale(0);
				opacity: 1;
			}
			100% {
				transform: scale(1);
				opacity: 1;
			}
		}

		.number-leave-active {
			animation: number-out 1s;
		}

		@keyframes number-out {
			0% {
				transform: scale(1);
				color: $colorSecondary;
				opacity: 0;
			}
			50% {
				transform: scale(5);
				color: $colorSecondary;
				opacity: 0.5;
			}
			75% {
				transform: scale(1);
				color: $colorSecondary;
				opacity: 0;
			}
			100% {
				transform: scale(1);
				color: $colorSecondary;
				opacity: 0;
			}
		}

		.cart-counter {
			position: absolute;
			width: 14px;
			height: 14px;
			font-size: 10px;
			font-weight: bold;
			background-color: $colorSecondary;
			border-radius: 100%;
			z-index: 5;
			right: 10px;
			top: -6px;
			> span {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				line-height: 15px;
				text-shadow: 0 1px 1px #0095c6;
			}
		}

		svg {
			width: 24px;
			height: 24px;
			fill: $colorPrimary3;
			transition: fill 200ms;
			&:focus {
				outline: none;
			}
		}

		.cart-info,
		.user-profile-info {
			> a:hover {
				svg {
					fill: $colorWhite;
				}
			}
		}

		.book-button {
			height: 100%;
			position: relative;
			font-family: Saira;
			font-size: 15px;
			font-weight: 600;
			letter-spacing: 0;
			line-height: 58px;
			color: $colorPrimary1;
			background: #59bdf6;
			text-decoration: none;
			padding: 0 20px;
			cursor: pointer;
			z-index: 11;
			transition: all 300ms 300ms;

			&:after {
				content: '';
				width: 0;
				height: 0;
				border-width: 13px 10px 0 10px;
				border-color: #27cafe transparent transparent transparent;
				border-style: solid;
				position: absolute;
				bottom: -13px;
				left: calc(50% - 10px);

				visibility: hidden;
				opacity: 0;
				transition: visibility 0s linear 600ms, opacity 300ms 300ms;
			}
			&--active {
				background: #27cafe;
				text-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
				position: relative;

				transition: all 300ms;

				&:after {
					visibility: visible;
					opacity: 1;
					transition: visibility 0s linear 0s, opacity 300ms;
				}
			}
		}
	}

	.icon {
		height: 24px;
		fill: $colorPrimary3;

		&_logo {
			height: 45px;
		}
	}
}
</style>
